import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const Plus = ({ color, size, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 3V13" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M13 8L3 8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

Plus.propTypes = {
  color: string,
  size: number,
};

Plus.defaultProps = {
  color: N400,
  size: 16,
};

export default Plus;
